import { ContactSearchScreen } from "types";
import { createScreen } from "../../../../utils/createScreen";

export const ContactSearchDefinition = createScreen({
  name: ContactSearchScreen,
  path: "/contact-search",
  routePath: ["/contact-search"],
  accessPath: "contactSearch",
});
